$(document).on("click", ".toggle-reason", function (_event) {
  let existing_reason = $("#rolling-reason").text().trim();
  let changed_reason = existing_reason == "Carrier change" ? "Supplier change" : "Carrier change";
  $("#rolling-reason").text(changed_reason);
  $('input[name ="reason"]').val(changed_reason);
  $("#decline-rollings").prop("disabled", true);
});

$(document).on("change", ".reason-select", function (_event) {
  let changed_reason = $(this).closest("td").find(".reason-select").val();
  $('input[name ="reason"]').val(changed_reason);
  $(this).closest("td").find('input[name ="reason"]').val(changed_reason);
  $(this).closest("td").find(".decline-rollings").prop("disabled", true);
});
